import { gql } from '@apollo/client';
import { type Relationship } from 'types/Relationship';
import { RELATIONSHIP_FRAGMENT } from './RelationshipFragments';

export const GET_RELATIONSHIPS_QUERY = gql`
  query GetRelationships {
    relationships {
      relationships {
        ...relationshipFields
      }
    }
  }
  ${RELATIONSHIP_FRAGMENT}
`;

export type GetRelationshipsOutput = {
  relationships: {
    relationships: Relationship[];
  };
};
